<app-add-note
	*ngIf="canRenderNotes() && showAddNote"
	[noteType]="noteType"
	[name]="name"
	[id]="id"
	[supportId]="supportId"
	[loadId]="loadId"
	[carrierId]="carrierId"
	[active]="hasActiveEdit === null"
	[feedbackInformation]="feedbackInformation"
	[showFeedback]="showFeedback"
	(textAreaClicked)="makeActive(null)"
	(cancelClicked)="makeActive(undefined)"
	(noteAdded)="addNote($event)"
	(feedbackAdded)="loadFeedback([$event], true)"
	[truckLaneId]="truckLaneId"
	[origin]="origin"
	[destination]="destination"
>
</app-add-note>
<div *ngIf="canRenderNotes()" (wheel)="onScroll()">
	<div *ngFor="let noteId of getCarrierNoteKeys()">
		<app-note
			*ngIf="
				(truckLaneId === null || carrierNotes.get(noteId).base.truckLaneId === truckLaneId) &&
				(!carrierId || carrierNotes.get(noteId).base.carrierId === carrierId)
			"
			[noteType]="noteType"
			[noteId]="noteId"
			[id]="id"
			[supportId]="isProjectType() ? carrierNotes.get(noteId).base.carrierId : supportId"
			[name]="
				isProjectType() ? (!!carrierNotes.get(noteId).base.carrierId ? undefined : name) : name
			"
			[carrierName]="
				isLoadType() ? carrierNameFor(carrierNotes.get(noteId).base.carrierId) : null
			"
			[defaultContent]="carrierNotes.get(noteId).base.notes"
			[createdDate]="carrierNotes.get(noteId).base.created"
			[modifiedDate]="carrierNotes.get(noteId).base.lastModified"
			[edit]="edit"
			[active]="carrierNotes.get(noteId).active"
			[feedbackInformation]="feedbackInformation"
			[showFeedback]="showFeedback"
			[feedback]="carrierNotes.get(noteId).feedback"
			[noteEditAndDeleteEnabled]="carrierNotes.get(noteId)?.noteEditAndDeleteEnabled"
			(editClicked)="makeActive(noteId)"
			(cancelClicked)="makeActive(undefined)"
			(noteDeleted)="deleteNote($event)"
			[user]="carrierNotes.get(noteId).user"
		>
		</app-note>
	</div>
</div>
